/**
 * Возвращаем объект со свойствами, где каждое свойство соответствует форме и содержит объект
 * с полями, которые обязательны к заполнению. Чтобы поле было обязательным в template нужному полю надо прописать
 * v-validate="required.property", где required - это объект с полями, который мы передаем в входных параметрах, а
 * property - это имя свойство в этом объекте. Соответственно для того чтобы добавить еще одно обязательное поле, надо в этот
 * объект добавить property: "required"
 */
export default {
  base: { title: "required", description: "required" },
  conveyors: {
    customer: "required",
    author: "required",
    address: "required",
    customerPhone: "required",
    customerRepresentative: "required",
    dateOfSale: "required",
    representativePhone: "required",
    specificationNumber: "required",
    request_form: "required",
    dateOfIncident: "required",
    details: "required",
    dateOfInstallation: "required",
    plannedOperatingTime: "required",
    actualOperatingTime: "required",
    tapeDesignation: "required"
  },
  EMCUserForm: {
    responsible_team: "required",
    reason_of_request: "required",
    priority: "required",
    work_type: "required"
  },
  crushing: {
    customer: "required",
    phone: "required",
    request_form: "required"
    //service_engineer: "required",
    //request_reason: "required",
    //incident_description: "required",
    // article_element: "required",
    // po_n: "required",
    // disassembling: "required",
    // disassembling_article_element: "required",
    // disassembling_article_original: "required",
    // disassembling_po_n: "required",
    // equipment: "required",
    // damage_1: "required",
    // damage_description: "required",
    // damage_2: "required",
    // customer_requirements: "required",
    // custom_unit: "required",
    // optime_average: "required",
    // optime_plan: "required",
    // material: "required",
    // size_1: "required",
    // size_2: "required"
  },
  grinding: {
    customer: "required",
    phone: "required",
    request_form: "required",
    service_engineer: "required",
    request_reason: "required",
    article_element: "required",
    damage_1: "required",
    damage_2: "required"
  },
  hydrotransport: {
    customer: "required",
    phone: "required",
    request_form: "required",
    service_engineer: "required",
    bill_num: "required",
    request_reason: "required",
    incident_description: "required",
    article_element: "required",
    article_original: "required",
    po_n: "required",
    equipment: "required",
    damage_1: "required",
    damage_description: "required",
    customer_requirements: "required",
    optime_plan: "",
    optime_actual: "",
    shs_param_1: "",
    shs_param_2: "",
    shs_param_3: "",
    shs_param_4: "",
    shs_param_5: "",
    shs_param_6: "",
    shs_param_7: "",
    shs_param_8: "",
    shs_param_9: "",
    shs_param_10: "",
    shs_param_11: "",
    shs_param_12: ""
  },
  headerForm: {
    theme: "required",
    company: "required",
    process: "required",
    group: "required"
  },
  addNewAccountForm: {
    fio: "required",
    email: "required",
    list_companies: "required",
    company: "required"
  }
};
